import styled, { css } from 'styled-components';
import { colors, mixins } from '../../css';

export const ScrollBox = styled.div`
  max-height: ${props => props.maxHeight && mixins.pxToRem(props.maxHeight)};
  overflow-y: auto;
  position: relative;
  padding: ${mixins.pxToRem(20)} 0;
  -webkit-overflow-scrolling: touch;
  text-align: left;

  ${props => {
    const { theme } = props;

    if (theme === 'border') {
      return css`
        background-color: ${colors.colorGrey05};
        border: ${mixins.pxToRem(1)} solid ${colors.colorBlue};
        padding: ${mixins.pxToRem(32)};
      `;
    }
    return null;
  }};
  /* 
    Custom Scroll bars
    this only works in webkit browsers
    */
  &::-webkit-scrollbar-track {
    width: ${mixins.pxToRem(5)};
  }
  &::-webkit-scrollbar {
    width: ${mixins.pxToRem(5)};
    background: ${colors.colorGrey04Rgba(0.2)};
    border-radius: ${mixins.pxToRem(2)};
  }
  &::-webkit-scrollbar-thumb {
    width: ${mixins.pxToRem(5)};
    background: ${colors.colorGrey04};
    border-radius: ${mixins.pxToRem(2)};
  }
`;

export const ShadowBox = styled.div`
  display: block;
  height: 10%;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;

  pointer-events: none;
  cursor: inherit;

  ${props => {
    const { shadowPosition } = props;

    if (shadowPosition === 'top') {
      return css`
        top: 0;
        transform: rotate(180deg);
      `;
    }
    return css`
      bottom: 0;
    `;
  }};

  box-shadow: inset 0 -50px 20px -30px
    ${props => (props.shadowColor === 'grey' ? colors.colorGrey05 : colors.colorWhite)};
`;

export const ContainerBox = styled.div`
  position: relative;
`;
